'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _extractModules = require('../core/extractModules');

var _extractModules2 = _interopRequireDefault(_extractModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-useless-escape */
var ARROW_ARG = /^([^\(]+?)=>/;
var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;

function extractArgs(fn) {
  var fnText = fn.toString().replace(STRIP_COMMENTS, '');
  var args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // #! For anonymous functions, showing at the very least the function signature
  // can help in
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && Array.isArray(arg)) {
    arg = arg[arg.length - 1];
  }

  return arg;
}

/**
 * > see: http://stackoverflow.com/questions/29093396/how-do-you-check-the-difference-between-an-ecmascript-6-class-and-function
 */
function isClass(func) {
  if (typeof func === 'function') {
    var funcStr = Function.prototype.toString.call(func);
    // un minify or babel or uglify
    return (/^class\s/.test(funcStr) || /_classCallCheck/.test(funcStr) || /^function (\w+)[\s\S]*?\w\(this,\1\);/.test(funcStr)
    );
  }
}

function annotate(fn, name) {
  var deps = Injector.getDependencies(fn);
  var argDecl = void 0;
  var last = void 0;

  if (!deps) {
    deps = [];
    if (typeof name !== 'string' || !name) {
      name = fn.name || anonFn(fn);
    }
    argDecl = extractArgs(fn);
    argDecl[1].split(FN_ARG_SPLIT).forEach(function (arg) {
      arg.replace(FN_ARG, function (all, underscore, name) {
        deps.push(name);
      });
    });
  } else if (Array.isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    deps = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return deps;
}

function invoke(Fn, serviceName, getService, self) {
  var deps = annotate(Fn, serviceName) || [];
  var args = [];
  var ctxs = {};
  var ctx = void 0;
  var length = void 0;
  var i = void 0;
  var key = void 0;

  for (i = 0, length = deps.length; i < length; i++) {
    key = deps[i];
    if (typeof key !== 'string') {
      throw new Error('Incorrect injection token! Expected service name as string');
    }
    ctx = getService(key);
    ctxs[key] = ctx;
    args.push(ctx);
  }
  if (Array.isArray(Fn)) {
    Fn = Fn[length];
  }

  if (isClass(Fn)) {
    var inst = new (Function.prototype.bind.apply(Fn, [null].concat(args)))();
    inst.context = ctxs;
    return inst;
  } else {
    // > see: http://jsperf.com/angularjs-invoke-apply-vs-switch
    self.context = ctxs;
    return Fn.apply(self, args);
  }
}

var Injector = function () {
  (0, _createClass3.default)(Injector, null, [{
    key: 'getDependencies',
    value: function getDependencies(Service) {
      if (Service.contextTypes) {
        return Object.keys(Service.contextTypes);
      } else {
        return Service.$inject;
      }
    }
  }]);

  function Injector(Services) {
    (0, _classCallCheck3.default)(this, Injector);

    this._services = {};
    if (Services) {
      this.setServices(Services);
    }
  }

  (0, _createClass3.default)(Injector, [{
    key: 'instantiate',
    value: function instantiate(provider, name, getService) {
      var _this = this;

      // + Check if Type is annotated and use just the given function at n-1 as
      // parameter  e.g. someModule.factory('greeter', ['$window',
      // function(renamed$window) {}]);  > Object creation:
      // http://jsperf.com/create-constructor/2
      var instance = Object.create(provider.prototype || null);
      var returnedValue = invoke(provider, name || provider.displayName, function (name) {
        var service = getService && getService(name);
        if (service) {
          return service;
        } else {
          return _this.getService(name);
        }
      }, instance);
      return Object(returnedValue) === returnedValue || typeof returnedValue === 'function' ? returnedValue : instance;
    }
  }, {
    key: 'setServices',
    value: function setServices(Services) {
      // #! 否则注入到全局服务中
      Services = (0, _extractModules2.default)(Services);
      for (var name in Services) {
        this.setService(Services[name]);
      }
    }
  }, {
    key: 'setService',
    value: function setService(Service) {
      var name = Service.displayName;
      if (name) {
        this._services[name] = this.instantiate(Service, name);
      } else if (Array.isArray(Service) || (0, _isPlainObject2.default)(Service)) {
        this.setServices(Service);
      } else {
        (0, _warning2.default)(false, _messages2.default.displayName, 'setService', 'injector', 'Beatle');
      }
    }
  }, {
    key: 'getService',
    value: function getService(name) {
      return this._services[name];
    }
  }]);
  return Injector;
}();

exports.default = Injector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/damo/injector.js
// module id = 126
// module chunks = 0